import './style.scss'
import { Slider } from '../../../js/components/Slider/Slider'
import { showOrderModal } from '../../popups/v1/OrderModal/scripts'

export default !function () {
  const blocks = document.querySelectorAll('.universal-community')

  if (!blocks.length) {
    return
  }

  blocks.forEach((block) => {
    const sliderContainer = block.querySelector('.universal-community-slider__slider')
    const slides = sliderContainer.querySelectorAll('.universal-community-slider__item')
    const controls = sliderContainer.querySelector('.universal-community-slider__controls')
    const isInitMobile = slides.length > 1
    const isInitTablet = slides.length > 2
    const isInitDesktop = slides.length > 3

    const options = {
      wrapper: sliderContainer,
      lazy: true,
      settings: {
        spaceBetween: 8,
        slidesPerView: 1,
        loop: false,

        effect: 'slide',

        slideClass: 'universal-community-slider__item',
        wrapperClass: 'universal-community-slider__list',

        pagination: {
          el: '.js-slider-count',
          type: 'fraction',
        },

        navigation: {
          nextEl: '.button-arrow--next',
          prevEl: '.button-arrow--prev'
        },

        breakpoints: {
          768: {
            spaceBetween: 24,
            slidesPerView: 2
          },
          1024: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 32,
            loop: true
          }
        },
      },
      modules: ['pagination', 'navigation', 'a11y'],
      initCondition: {
        sm: isInitMobile,
        md: isInitTablet,
        lg: isInitDesktop,
        xl: isInitDesktop
      },
      controls
    }

    new Slider(options).init()

    const blockName = block.closest('[data-block-name]')?.dataset.blockName || 'Блок без названия'
    const actionButton = block.querySelector('.universal-community-midsection__button')

    actionButton?.addEventListener('click', () => {
      if (actionButton.dataset.actionButton === 'order-modal') {
        showOrderModal({ blockName })
      }

      const buttonType = actionButton.dataset.actionButton || (actionButton.dataset.redirectLink && 'redirect')

      buttonType && window.$analytics?.push('all-block-consult-button-click', {
        blockName,
        buttonType,
        buttonText: actionButton.textContent
      })
    })
  })
}()
